import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import axios from "axios";
import {Status} from "./status";
import {headers} from "./headers";
import {Action} from "./Shot";
import {host} from "./api";


export interface ActionState {
    status: Status,
    error: string | null | undefined
}

const initialState: ActionState = {
    status: Status.Idle,
    error: null,
}

export const saveAction = createAsyncThunk('saveAction', async (params: { projectId: number, choiceId: number, action: Action }) => {
    const response = await axios.post(`${host}/choices/${params.choiceId}/actions`,
        params.action,
        {
            headers: headers(params.projectId?.toString())
        })
    return response.data
})

export const saveShotAction = createAsyncThunk('saveShotAction', async (params: { projectId: number, shotId: number, action: Action }) => {
    const response = await axios.post(`${host}/shots/${params.shotId}/actions`,
        params.action,
        {
            headers: headers(params.projectId?.toString())
        })
    return response.data
})

export const addActionToChoice = createAsyncThunk('setActionToChoice', async (params: { projectId: number, choiceId: number, actionId: number }) => {
    const response = await axios.post(`${host}/choices/${params.choiceId}/actions/${params.actionId}`,
        {},
        {
            headers: headers(params.projectId?.toString())
        })
    return response.data
})

export const addActionToShot = createAsyncThunk('setActionToShot', async (params: { projectId: number, shotId: number, actionId: number }) => {
    const response = await axios.post(`${host}/shots/${params.shotId}/actions/${params.actionId}`,
        {},
        {
            headers: headers(params.projectId?.toString())
        })
    return response.data
})

export const deleteAction = createAsyncThunk('deleteAction', async (params: { projectId: number, actionId: number }) => {
    const response = await axios.delete(`${host}/actions/${params.actionId}`,
        {
            headers: headers(params.projectId?.toString())
        })
    return response.data
})

export const actionSlice = createSlice({
    name: 'choices',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
          .addCase(saveAction.pending, (state, action) => {
                state.status = Status.Loading
            })
            .addCase(saveAction.fulfilled, (state, action) => {
                state.status = Status.Idle
            })
            .addCase(deleteAction.pending, (state, action) => {
                state.status = Status.Loading
            })
            .addCase(deleteAction.fulfilled, (state, action) => {
                state.status = Status.Idle
            })
            .addCase(addActionToChoice.pending, (state, action) => {
                state.status = Status.Loading
            })
            .addCase(addActionToChoice.fulfilled, (state, action) => {
                state.status = Status.Idle
            })
            .addCase(addActionToShot.pending, (state, action) => {
                state.status = Status.Loading
            })
            .addCase(addActionToShot.fulfilled, (state, action) => {
                state.status = Status.Idle
            })
            .addCase(saveShotAction.pending, (state, action) => {
                state.status = Status.Loading
            })
            .addCase(saveShotAction.fulfilled, (state, action) => {
                state.status = Status.Idle
            })

    }
})
export default actionSlice.reducer;